import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { INotificationHandler, INotificationView, UserAppNotificationService } from '@engineering11/notifications-web'
import { ICultureIndexSurveyResponseNotification } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class CultureIndexSurveyResponseHandler implements INotificationHandler<ICultureIndexSurveyResponseNotification, INotificationView> {
  notificationType: string = 'cultureindex_cultureindex_survey_response'
  constructor(private router: Router, private userAppNotificationService: UserAppNotificationService) {}

  onClick(notification: ICultureIndexSurveyResponseNotification): boolean | Promise<boolean> {
    if (!notification.viewed) {
      this.userAppNotificationService.markNotificationAsRead(notification.id)
    }
    return this.router.navigate(['/jobs/candidates/', notification.jobPostId], { queryParams: { candidateId: notification.candidateApplicationId } })
  }
}
